function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

const diff = require('../utils/diff');

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

const _ = require('lodash');

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

const PagedList = require('../entities/paged-list');

const AccessContext = require('./contexts/access-context');

const {
  Offer,
  SimpleFlow,
  Schedule
} = require('../entities');

const OfferLocationsRepo = require('./offer-locations-repo');

const OfferFlowsRepo = require('./offer-flows-repo');

const OfferRegionsRepo = require('./offer-regions-repo');

const offerDetailsPipeline = require('./offer-details-pipeline');

const {
  serializeImages,
  findImage,
  findImages
} = require('../utils/entities');

const OfferUpdatePipeline = require('../pipelines/offer-update-pipeline');

const StatsRepo = require('./stats-repo');

const RatingRepo = require('./rating-repo');

const TagsRepo = require('./tags-repo');

const {
  strList,
  strinct,
  nullable
} = require('../utils/serialize');

const OfferCodesRepo = require('./offer-codes-repo');

const OfferLocalizerFactory = require('../entities/offer-localizer');

const OfferLocalizationDictionary = require('../entities/offer-localization-dictionary');

const getPropertyLocales = require('../utils/get-property-locales');

const {
  schedulesToPrecheckParams
} = require('../utils/scheduleToPrecheckParam');

const {
  poll
} = require('../utils/poll');

const {
  newScheduleDates,
  serializeDate
} = require('../utils/dates');

const TYPE_NAME = TagsRepo.TYPE_NAMES.offer;

function parse(json) {
  const offer = new Offer({
    id: json.id,
    slug: json.slug,
    headline: json.headline,
    subHeadline: json.subhead,
    details: json.details,
    legal: json.legal,
    keywords: json.keywords,
    heroImage: findImage(json.images, 'offer-hero-standard'),
    heroImages: findImages(json.images, 'offer-hero-standard'),
    heroImageUrl: _.get(json, 'heroImages[0].url'),
    heroImageUrls: json.heroImages && json.heroImages.map(item => item.url),
    businessId: json.businessId,
    business: json.business,
    propertyId: json.propertyId,
    flowId: json.flowId,
    promoCode: json.promoCode,
    enabled: json.enabled,
    flags: json.flags,
    status: json.status,
    shareUri: json.shareUri,
    shareUrl: json.shareUrl,
    syndicated: json.isOwned === false,
    hasStats: json.hasStats,
    priority: json.priority,
    locationIds: json.locations && json.locations.map(l => l.id),
    locations: json.locations,
    visibleSchedules: json.visibleSchedules,
    discoverableSchedules: json.discoverableSchedules,
    usableSchedules: json.usableSchedules,
    schedules: json.usableSchedules && json.usableSchedules.map(scheduleJson => Schedule.fromJson(scheduleJson)),
    scheduleIds: json.scheduleIds,
    tags: json.tags,
    rating: json.rating
  });
  return offer;
}

function serialize(data) {
  return {
    id: data.id,
    headline: data.headline,
    subhead: data.subHeadline,
    details: data.details,
    legal: nullable(strinct)(data.legal),
    keywords: data.keywords,
    images: serializeImages(data.heroImages),
    promoCode: nullable(strinct)(data.promoCode),
    flags: data.flags,
    priority: data.priority,
    scheduleIds: data.scheduleIds,
    sourceId: data.sourceId
  };
}

const fields = ['id', 'businessId', 'propertyId', 'slug', 'headline', 'subhead', 'details', 'promoCode', 'legal', 'keywords', 'images', 'flowId', 'flags', 'enabled', 'shareUri', 'priority', 'scheduleIds'];
const searchFields = ['id', 'slug', 'heroImages.url', 'businessId', 'propertyId', 'headline', 'subhead', 'details', 'enabled', 'flags', 'business(name,categories(name,shortName,parentCategoryId),tags(name),policies(plan(id,name)))', 'status', 'locations(id,name,tags(name),accessible)', // 'id' is For Location User access filtering
'visibleSchedules(startDate,endDate)', 'usableSchedules(startDate,endDate)', 'discoverableSchedules(startDate,endDate)', 'isOwned', 'hasStats', 'tags(name)', 'priority', 'rating'];
const searchFieldsWithBusiness = ['id', 'slug', 'heroImages.url', 'businessId', 'propertyId', 'headline', 'subhead', 'details', 'enabled', 'flags', 'business(name,categories(shortName,parentCategoryId))', 'status', 'locations(id,name,accessible)', // 'id' is For Location User access filtering
'visibleSchedules(startDate,endDate)', 'usableSchedules(startDate,endDate)', 'discoverableSchedules(startDate,endDate)', 'isOwned', 'hasStats', 'priority', 'rating'];
const singleSearchFields = ['id', 'slug', 'heroImages.url', 'businessId', 'propertyId', 'headline', 'subhead', 'details', 'legal', 'enabled', 'flags', 'status', 'business(name,profileImages.url,heroStandardImages.url,categories(shortName,parentCategoryId))', 'locations(id,name,address(city,centre),accessible)', // 'id' is For Location User access filtering
'visibleSchedules(startDate,endDate)', 'usableSchedules(id,type,startDate,endDate,weekDays,minutes)', 'discoverableSchedules(startDate,endDate)', 'isOwned', 'hasStats', 'shareUri', 'shareUrl', 'rating'];
const singleSearchFieldsWithBusiness = singleSearchFields.concat('priority');

const getSearchFields = (offerId, businessId) => {
  if (offerId) {
    if (businessId) return singleSearchFieldsWithBusiness;
    return singleSearchFields;
  }

  if (businessId) return searchFieldsWithBusiness;
  return searchFields;
};

class OfferRepo {
  constructor(client
  /*: ApiClient*/
  , id
  /*: offerId*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.id = id;
    this.context = context;
    this.locations = new OfferLocationsRepo(client, context, id);
    this.flows = new OfferFlowsRepo(client, context, id);
    this.regions = new OfferRegionsRepo(client, context, id);
    this.stats = new StatsRepo(client, context, id);
    this.rating = new RatingRepo(client, context, id);
    this.codes = new OfferCodesRepo(client, context, id);
  }

  buildPath() {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const offerId = this.id;
    if (!businessId) return `/properties/${propertyId}/offers/${offerId}`;
    return `/properties/${propertyId}/businesses/${businessId}/offers/${offerId}`;
  }

  getIndexedOffer(locale = []) {
    const _this = this;

    return _call(function () {
      const {
        propertyId,
        businessId
      } = _this.context.serialize();

      const offerId = _this.id;
      return _await(_this.client.properties.for(propertyId).businesses.for(businessId).offers.list({
        offerId,
        locale
      }).catch(() => ({
        items: []
      })) // HACK: Ignore errors
      .then(({
        items
      }) => items[0]));
    });
  }

  details(locale = [])
  /*: Promise<Offer>*/
  {
    const _this2 = this;

    return _call(function () {
      return _await(_this2.getIndexedOffer(locale), function (indexedOffer) {
        return indexedOffer && indexedOffer.syndicated ? indexedOffer : _await(offerDetailsPipeline(_this2.client, _this2.context, parse, fields, _this2.id), function (offer) {
          // shareUrl only available from search index =\
          offer.shareUrl = indexedOffer && indexedOffer.shareUrl; // HACK: Add offer status from index
          // The offer's status is not available from the raw offer.
          // This means the status' updates will be delayed until the search index updates.

          offer.status = indexedOffer && indexedOffer.status;
          /*
            HACK: If an offer is requested in a specific locale then the indexedOffer is returned in that locale,
            however the offer returned from offerDetailsPipeline has no context about requesting with a passed in locale,
            so the details need to be manually updated for now.
          */

          if (locale.length && indexedOffer) {
            offer.details = indexedOffer.details;
            offer.headline = indexedOffer.headline;
            offer.subHeadline = indexedOffer.subHeadline;
            offer.legal = indexedOffer.legal; // Keep track of the locale if the offer was requested with one

            offer.locale = locale[0];
          }

          if (indexedOffer && indexedOffer.locations) {
            offer.canEdit = indexedOffer.locations.every(l => l.accessible);
          } else {
            // HACK: If there's no index for the offer yet, we assume the user can edit it because
            // they almost certainly got here by creating it
            offer.canEdit = true;
          }

          return offer;
        });
      }); // HACK: Return raw indexed offer if it's syndicated
    });
  }

  duplicate(allowAdvanced = true)
  /*: Promise<OfferUpdatePipeline>*/
  {
    const _this3 = this;

    return _call(function () {
      return _await(_this3.edit(), function (newOfferPipeline) {
        const oldFlow = newOfferPipeline.getInstance('flow');
        const oldDetails = newOfferPipeline.getInstance('offer');
        const oldSchedules = newOfferPipeline.getInstance('schedules');
        newOfferPipeline.setInstance('offer', _.omit(oldDetails, ['id', 'schedules', 'priority', 'slug']));
        newOfferPipeline.setInstance('schedules', Schedule.duplicate(oldSchedules, allowAdvanced));
        newOfferPipeline.setInstance('flow', SimpleFlow.duplicate(oldFlow));
        return newOfferPipeline;
      });
    });
  }

  getLocalizations()
  /*: Promise<PagedList<any>>*/
  {
    const ALL_LOCALE_FIELDS = ['id', 'type', 'modelId', 'locale', 'content', 'priority', 'propertyId'];
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const offerId = this.id;
    const path = `/properties/${propertyId}/businesses/${businessId}/offers/${offerId}/localizations`;
    const req = new this.client.Request(path, {}, ALL_LOCALE_FIELDS);
    req.parse = OfferLocalizationDictionary.fromJson;
    return this.client.get(req);
  }

  setLocalization({
    locale,
    content,
    isDefault
  })
  /*: Promise<any>*/
  {
    const setFields = ['id'];
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const offerId = this.id;
    const path = `/properties/${propertyId}/businesses/${businessId}/offers/${offerId}/localizations`;
    const params = {
      locale,
      content,
      default: Boolean(isDefault)
    };
    const req = new this.client.Request(path, params, setFields);
    req.serialize = OfferLocalizationDictionary.serialize;
    return this.client.post(req);
  }

  getValidations()
  /*: Promise<any>*/
  {
    const getFields = [];
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const offerId = this.id;
    const path = `/properties/${propertyId}/businesses/${businessId}/offers/${offerId}/validation`;
    const req = new this.client.Request(path, {}, getFields);
    return this.client.get(req);
  }

  edit()
  /*: Promise<OfferUpdatePipeline>*/
  {
    const _this4 = this;

    return _call(function () {
      // FIXME: Get the old details format and transform it into the new one.
      // FIXME: Replace this with a builder that gets the data and returns an OfferUpdatePipeline instance
      return _await(_this4.details(), function (oldDetails) {
        return _await(getPropertyLocales(_this4), function (locales) {
          return _await(_this4.getLocalizations(), function (_this4$getLocalizatio) {
            const translations = _this4$getLocalizatio.items;
            OfferLocalizerFactory(locales).setLocalizations(oldDetails, translations);
            const offerUpdate = new OfferUpdatePipeline(_this4.client, _this4.context);
            const defaultEndDate = serializeDate(newScheduleDates().yearFromCurrentDate);
            oldDetails.schedules.forEach(s => {
              // eslint-disable-next-line no-param-reassign
              if (!s.endDate) s.endDate = defaultEndDate;
            });
            offerUpdate.setInstance('offer', _.omit(oldDetails, ['schedules', 'locations', 'regions', 'flow']));
            offerUpdate.setInstance('locales', locales);
            offerUpdate.setInstance('schedules', oldDetails.schedules);
            offerUpdate.setInstance('locations', (oldDetails.locations || []).map(location => location.id));
            offerUpdate.setInstance('redeemableRegions', oldDetails.redeemableRegions);
            offerUpdate.setInstance('discoverableRegions', oldDetails.discoverableRegions);
            offerUpdate.setInstance('flow', oldDetails.flow);
            return offerUpdate;
          });
        });
      });
    });
  }

  coreDetails()
  /*: Promise<Offer>*/
  {
    const req = new this.client.Request(`${this.buildPath()}`, undefined, fields);
    return this.client.get(req);
  }

  delete()
  /*: (Promise<boolean>)*/
  {
    const _this5 = this;

    return _call(function () {
      // Unlink Regions...
      return _await(_this5.regions.unlinkAll(), function () {
        return _this5.client.delete(new _this5.client.Request(_this5.buildPath()));
      });
    });
  }

  enable()
  /*: (Promise<boolean>)*/
  {
    const _this6 = this;

    return _call(function () {
      return _await(_this6.getLocations(), function (locations) {
        if (locations.items.length === 0) throw new Error('Offer cannot be published without Locations');
        const req = new _this6.client.Request(`${_this6.buildPath()}/enable`);
        return _this6.client.post(req);
      });
    });
  }

  disable()
  /*: (Promise<boolean>)*/
  {
    const req = new this.client.Request(`${this.buildPath()}/disable`);
    return this.client.post(req);
  } // Limit precheck which preloads the offer locations/schedules
  // The limit precheck on the backend uses the search index which may not be synchronized yet
  // Eventually, we'll have this fixed. But for now we're going to do it the hard way...
  // TODO: Remove this when the backend precheck can guarantee schedules are synchronized


  checkLimits()
  /*: Promise<boolean>*/
  {
    const _this7 = this;

    return _call(function () {
      const {
        propertyId,
        businessId
      } = _this7.context.serialize();

      const offerId = _this7.id;
      return _await(_this7.coreDetails(), function (_this7$coreDetails) {
        const offerScheduleIds = _this7$coreDetails.scheduleIds;
        return _await(Promise.all([_this7.getLocations(), Promise.all(offerScheduleIds.map(id => _this7.client.schedules.for(id).details()))]), function ([locations, schedules]) {
          const locationIds = locations.items.map(({
            id
          }) => id);
          return _this7.client.properties.for(propertyId).businesses.for(businessId).checkLimits({
            offerId,
            locationIds,
            visibleSchedules: schedulesToPrecheckParams(schedules, 'visible'),
            discoverableSchedules: schedulesToPrecheckParams(schedules, 'discoverable'),
            usableSchedules: schedulesToPrecheckParams(schedules, 'usable')
          });
        });
      });
    });
  }

  addLocation(locationId
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const offerId = this.id;
    const path = `/properties/${propertyId}/businesses/${businessId}/offers/${offerId}/locations/${locationId}/link`;
    const req = new this.client.Request(path);
    return this.client.put(req);
  }

  removeLocation(locationId
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const offerId = this.id;
    const path = `/properties/${propertyId}/businesses/${businessId}/offers/${offerId}/locations/${locationId}/link`;
    const req = new this.client.Request(path);
    return this.client.delete(req);
  }

  getLocations()
  /*: Promise<any>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const offerId = this.id;
    const path = `/properties/${propertyId}/businesses/${businessId}/offers/${offerId}/locations`;
    const req = new this.client.Request(path, undefined, ['id']);
    return this.client.get(req);
  }

  coreUpdate(instance, updates)
  /*: Promise<any>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize(); // TODO: This should come from the context, not the instance

    const offerId = instance.id;
    if (!offerId) throw new Error('Missing required parameter offer id');
    const path = `/properties/${propertyId}/businesses/${businessId}/offers/${offerId}`;
    const updatedProps = diff(instance, updates); // HACK: we need to be able to clear promoCode

    if (instance.promoCode && !updates.promoCode) updatedProps.promoCode = null;
    const req = new this.client.Request(path, updatedProps, fields);
    req.parse = parse;
    req.serialize = serialize;
    return this.client.patch(req);
  }

  updateSlug(newSlug
  /*: string*/
  )
  /*: Promise<string>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const offerId = this.id;
    const path = `/properties/${propertyId}/businesses/${businessId}/offers/${offerId}/slugs`;
    const req = new this.client.Request(path, {
      inputString: newSlug
    }, ['slug']);
    return this.client.post(req).then(response => response.slug);
  }

  getTags()
  /*: (Promise<any>)*/
  {
    const {
      propertyId
    } = this.context.serialize();
    const offerId = this.id;
    return this.client.tags.list(propertyId, TYPE_NAME, offerId);
  }

  updateTags(newTags
  /*: Array<string>*/
  )
  /*: (Promise<any>)*/
  {
    const {
      propertyId
    } = this.context.serialize();
    const offerId = this.id;
    return this.client.tags.reconcile(propertyId, TYPE_NAME, offerId, newTags);
  }

  addTag(tagName
  /*: string*/
  )
  /*: (Promise<any>)*/
  {
    const {
      propertyId
    } = this.context.serialize();
    const offerId = this.id;
    return this.client.tags.create(propertyId, TYPE_NAME, offerId, tagName).then(() => true).catch(() => false);
  }

  removeTag(tagName
  /*: string*/
  )
  /*: (Promise<any>)*/
  {
    const {
      propertyId
    } = this.context.serialize();
    const offerId = this.id;
    return this.client.tags.delete(propertyId, TYPE_NAME, offerId, tagName).then(() => true).catch(() => false);
  }
  /**
   * Approve an offer for syndication.
   *
   * Should be replaced with `syndicate()`
   * @deprecated
   */


  whitelist()
  /*: Promise<boolean>*/
  {
    const _this8 = this;

    return _call(function () {
      const {
        propertyId,
        businessId,
        locationId
      } = _this8.context.serialize(); // NOTE: If a locationId is specified and the current user only has access to a _different_ location,
      // they technically could whitelist the offer but they'd need to specify a location they have access to.


      const offerId = _this8.id;
      const path = [`/properties/${propertyId}`, businessId ? `/businesses/${businessId}` : null, locationId ? `/locations/${locationId}` : null, `/offers/${offerId}/approve`].filter(Boolean).join('');
      const req = new _this8.client.Request(path);
      return _await(_this8.client.post(req).then(() => true));
    });
  }
  /**
   * Deny an offer for syndication.
   *
   * Should be replaced with `unsyndicate()`
   * @deprecated
   */


  blacklist()
  /*: Promise<boolean>*/
  {
    const {
      propertyId,
      businessId,
      locationId
    } = this.context.serialize();
    if (businessId || locationId) throw new Error('Offers can only be blacklisted at the Property level');
    const offerId = this.id;
    const path = `/properties/${propertyId}/offers/${offerId}/decline`;
    const req = new this.client.Request(path);
    return this.client.post(req).then(() => true);
  }
  /**
   * Approve offer from another property and enable business and locations if required
   * @returns {Promise<boolean>}
   */


  syndicate()
  /*: Promise<boolean>*/
  {
    const _this9 = this;

    return _call(function () {
      const {
        propertyId
      } = _this9.context.serialize();

      return _await(_this9.details(), function (offer) {
        return _await(_this9.whitelist(), function () {
          const businessId = offer.businessId;
          const policyRepo = _this9.client.policy;
          return _await(policyRepo.ensureActivePolicy(propertyId, businessId), function (policy) {
            return _await(policyRepo.reconcileLocations(propertyId, businessId, policy.id, offer.locationIds, {
              addOnly: true
            }), function () {
              return true;
            });
          });
        });
      });
    });
  }
  /**
   * Decline an offer from another property
   * @returns {Promise<boolean>}
   */


  unsyndicate()
  /*: Promise<boolean>*/
  {
    const _this10 = this;

    return _call(function () {
      const {
        propertyId
      } = _this10.context.serialize();

      const offerId = _this10.id;
      return _await(_this10.client.properties.for(propertyId).offers.for(offerId).blacklist(), function () {
        return true;
      });
    });
  }

  waitForIndex(compareFn
  /*: Function*/
  , onTimeout
  /*: Function*/
  )
  /*: Promise<boolean>*/
  {
    const _this11 = this;

    return _call(function () {
      const predicate = _async(function ()
      /*: Promise<boolean>*/
      {
        return _await(_this11.getIndexedOffer(), function (result) {
          return result ? compareFn ? compareFn(result) : true : false;
        });
      });

      return _await(poll(predicate, 1000, 5000).catch(err => {
        if (!err.isTimeout) throw err;
        /* eslint-disable-next-line no-console */

        console.error(new Error('Waiting for offer for more than 5 seconds...'));
        return poll(predicate, 1000, 25000, onTimeout);
      }));
    });
  }

}
/**
 * @class OffersRepo
 * @classdesc Repository for interating with lists of offers
 */


class OffersRepo {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.context = context;

    this.for = (id
    /*: offerId*/
    ) => new OfferRepo(client, id, context);

    this.icanhas = this.for;
  }

  buildPath() {
    const {
      propertyId,
      businessId,
      locationId
    } = this.context.serialize();

    if (!businessId) {
      return `/properties/${propertyId}/offers`;
    } else if (!locationId) {
      return `/properties/${propertyId}/businesses/${businessId}/offers`;
    }

    return `/properties/${propertyId}/businesses/${businessId}/locations/${locationId}/offers`;
  }
  /**
   * Load a list of offers
   *
   * The options are all very confusing. The examples are "as-is" how current usage
   * works, but the documentation & details need to be cleaned up because it's
   * too easy to make mistakes.
   *
   * @async
   * @param {Object} params
   * @param {Object} options - standard options for requests
   * @return {Promise<PagedList<Offer>>}
   *
   * @example
   *
   *     // Load currently live offers in a property
   *     list({ status: ['live', 'scheduled'], isVisible: true, })
   *
   * @example
   *
   *     // Load offers available for syndication
   *     list({ isGlobal: true, state: ['PENDING'], enabled: true, status: ['live'], })
   */


  list({
    /*: {
        query?: string,
        tags?: Array<string>,
        enabled: ?boolean,
        status: Array<string>,
        timeLimits: Object,
        isOwned: ?boolean,
        isGlobal: ?boolean,
        hasStats: ?boolean,
        state?: ?Array<string>,
        isVisible?: ?boolean,
        includeHistoric?: ?boolean,
        offerId: ?string,
        locale: ?Array<string>,
        sort: ?string,
        limit: ?number,
        planIds: ?Array<string>,
        hasRoles: ?boolean,
        skipAccessCheck: ?boolean,
        flags: ?Array<string>
      }*/

    query,
    tags,
    enabled,
    // ????
    status,
    // schedule status ("live", "scheduled", "expired")
    timeLimits = {},
    isOwned,
    // belongs to current property
    isGlobal,
    // is available from the global offer pool
    hasStats,
    // has generated stats under current property
    state,
    // greylist approval status, based on current property ("PENDING", "APPROVED", "DECLINED")
    isVisible,
    // greylist visible status for current property. TODO: Does this apply to ALL offers...?
    includeHistoric,
    // true to include offers which are only related to the current property via historical stats
    offerId,
    // fetch a specific offer from the index
    locale,
    // try to fetch in preferred locale
    sort,
    limit,
    planIds,
    hasRoles,
    skipAccessCheck,
    flags
  } = {}, options
  /*: RequestOptions*/
  = {})
  /*: (Promise<PagedList<Offer>>)*/
  {
    const _this12 = this;

    return _call(function () {
      const {
        businessId
      } = _this12.context.serialize();

      const offerAccessTransform = offerList => {
        if (!hasRoles) return offerList;
        return offerList.copy(offers => offers.filter(o => o.locations.some(l => l.accessible)));
      };

      const params = {
        q: strinct(query),
        tagNames: strList(tags),
        status: strList(status),
        enabled,
        minStartTime: timeLimits.minStartTime,
        maxStartTime: timeLimits.maxStartTime,
        minEndTime: timeLimits.minEndTime,
        maxEndTime: timeLimits.maxEndTime,
        isOwned,
        isGlobal,
        hasStats,
        state: strList(state),
        isVisible,
        includeHistoric,
        offerId,
        locale: strList(locale),
        sort,
        limit,
        planIds: strList(planIds),
        flags: strList(flags)
      };
      const path = hasRoles ? `/self${_this12.buildPath()}/search` : `${_this12.buildPath()}/search`;
      const req = new _this12.client.Request(path, params, // This allows you to directly override the fields, but it does NOT allow you to
      // 'extend' fields. This is because fields are currently stored as an array string,
      // but can be nested (ie. "locations(id,name,tags(name))"). To support the 'extend'
      // fields use case, the internal representation of fields would need to be converted
      // to nested arrays that get flattened dynamically at request time, which is WAY
      // outside the scope of this change.
      options.fields ? options.fields : getSearchFields(offerId, businessId));
      req.parse = parse;
      req.transform = offerAccessTransform;
      return _await(_this12.client.get(req));
    });
  }

  listRaw() {
    const req = new this.client.Request(this.buildPath(), {}, fields);
    req.parse = parse;
    return this.client.get(req);
  }

  coreCreate(updates
  /*: Object*/
  )
  /*: Promise<Offer>*/
  {
    const _this13 = this;

    return _call(function () {
      const {
        propertyId,
        businessId
      } = _this13.context.serialize();

      const path = `/properties/${propertyId}/businesses/${businessId}/offers`;
      const req = new _this13.client.Request(path, updates, fields);
      req.parse = parse;
      req.serialize = serialize;
      return _await(_this13.client.post(req));
    });
  } // eslint-disable-next-line class-methods-use-this


  initializeSchedule()
  /*: Schedule*/
  {
    const {
      currentDate,
      yearFromCurrentDate
    } = newScheduleDates();
    return new Schedule({
      startDate: serializeDate(currentDate),
      endDate: serializeDate(yearFromCurrentDate),
      weekDays: [0, 1, 2, 3, 4, 5, 6],
      timeRanges: [['00:00', '00:00']],
      evergreen: true,
      advanced: false
    });
  }

  initialize()
  /*: Promise<OfferUpdatePipeline>*/
  {
    const _this14 = this;

    return _call(function () {
      const {
        propertyId,
        businessId
      } = _this14.context.serialize();

      const offerUpdate = new OfferUpdatePipeline(_this14.client, _this14.context);
      offerUpdate.setInstance('offer', new Offer({
        enabled: false,
        flags: ['exclusive'],
        headline: '',
        propertyId,
        businessId
      }));
      return _await(getPropertyLocales(_this14), function (locales) {
        offerUpdate.setInstance('locales', locales);
        offerUpdate.setInstance('schedules', [_this14.initializeSchedule()]);
        return _await(_this14.client.properties.for(propertyId).businesses.for(businessId).locations.list({
          enabled: true,
          hasRoles: true,
          accessContext: 'implicit'
        }).then(_this14.client.pagination.loadRest), function (locations) {
          offerUpdate.setInstance('locations', locations.items.map(loc => loc.id));
          const simpleFlow = new SimpleFlow();
          offerUpdate.setInstance('flow', simpleFlow);
          return offerUpdate;
        });
      });
    });
  }

}

module.exports = OffersRepo;